import avatarAdjunto from "../assets/avatares/adjunto.png";
import avatarEnfermeria from "../assets/avatares/enfermeria.png";
import avatarOncologia from "../assets/avatares/oncologia.png";
import avatarPatologia from "../assets/avatares/patologia.png";
import avatarRadiologia from "../assets/avatares/radiologia.png";

export const SPECIALIST_TOTAL_USES = 3;

export const SPECIALIST_PROFILES = [
	{ id: "nurse", label: "Enfermería", cost: 4 },
	{ id: "path", label: "Patólogo", cost: 6 },
	{ id: "radio", label: "Radiólogo", cost: 6 },
	{ id: "onco", label: "Oncólogo", cost: 7 },
	{ id: "attending", label: "Adjunto", cost: 8 },
];

/** URL del avatar por id de perfil (webpack) */
export const SPECIALIST_AVATAR_BY_PROFILE_ID = {
	nurse: avatarEnfermeria,
	path: avatarPatologia,
	radio: avatarRadiologia,
	onco: avatarOncologia,
	attending: avatarAdjunto,
};

export function getSpecialistAvatarSrc(profileId) {
	return SPECIALIST_AVATAR_BY_PROFILE_ID[profileId] || avatarEnfermeria;
}

/**
 * Texto de ayuda por escenario y perfil.
 * Mantenerlo corto y accionable; se muestra en modal desde TopBar.
 */
export const SPECIALIST_HELP = {
	2: {
		nurse:
			"Pacientes estables con sospecha de CCR: prioriza completar pruebas clave sin retrasos, vigila signos de obstrucción/perforación y coordina circuitos (endoscopia/biopsia/analítica).",
		path:
			"Confirmación diagnóstica = histología. La imagen endoscópica orienta, pero el diagnóstico definitivo de cáncer colorrectal se establece con el informe anatomopatológico (adenocarcinoma invasivo).",
		radio:
			"Antes de decidir tratamiento, completa estadificación con imagen estructural. Habitualmente TC toraco‑abdomino‑pélvica para extensión a distancia y evaluación global.",
		onco:
			"Tras confirmación histológica, el siguiente paso es estadificar (TC TAP) y obtener un CEA basal. El tratamiento depende de estadio, resecabilidad y estado general.",
		attending:
			"Piensa en secuencia: 1) confirmar con colonoscopia/biopsia, 2) estadificar con TC TAP + CEA basal, 3) decidir plan (quirúrgico/adyuvante/paliativo) según estadio.",
	},
	3: {
		nurse:
			"En estratificación, asegúrate de que los datos clave estén disponibles antes de la decisión: informes completos, fechas, y que el equipo tenga claro qué falta por pedir.",
		path:
			"En tumores, histología y grado importan para el plan. Cuando haya biopsias, busca tipo, invasión y (si aplica) biomarcadores clave del escenario.",
		radio:
			"En estratificación, la imagen define extensión y resecabilidad. Identifica qué prueba responde a la pregunta clínica (local vs sistémica).",
		onco:
			"En estratificación, clasificar bien (riesgo/estadio/volumen) es lo que guía el tratamiento. No avances sin la variable que separa rutas terapéuticas.",
		attending:
			"Tu objetivo es reducir incertidumbre antes de tratar: confirma el dato que cambia la conducta (estadio/volumen/resecabilidad) y sigue la secuencia lógica.",
	},
	4: {
		nurse:
			"En tratamiento, valora tolerancia y logística: comorbilidades, función renal/hepática, y seguridad del circuito (premedicación, controles).",
		path:
			"Si el tratamiento depende de un marcador/hallazgo tisular, asegúrate de que esté reportado y sea interpretable antes de escoger terapia.",
		radio:
			"En tratamiento, la imagen sirve para respuesta y para confirmar progresión. Asegura comparabilidad (misma técnica/criterios).",
		onco:
			"Elige tratamiento alineado con estadio y situación clínica; prioriza lo que cambia supervivencia/beneficio claro frente a secuencias de bajo rendimiento.",
		attending:
			"En tratamiento, justifica con guía: qué terapia es estándar en este escenario, y por qué las alternativas no son primera línea.",
	},
	5: {
		nurse:
			"En seguimiento, lo importante es un plan: qué monitorizas, cada cuánto, y qué umbral dispara una actuación (síntomas, labs, imagen).",
		path:
			"En seguimiento, patología suele ser menos central; céntrate en criterios de respuesta/recidiva del escenario.",
		radio:
			"Define qué imagen y periodicidad; usa criterios de progresión/respuesta (cuando aplique) y compara con baseline.",
		onco:
			"Seguimiento = detectar recaída/progresión y toxicidad a tiempo. Define triggers claros para cambiar estrategia.",
		attending:
			"Piensa como checklist: monitorización + criterios de cambio + educación al paciente. Evita pruebas sin impacto en conducta.",
	},
};

export function getSpecialistHelpText(scenarioNum, profileId) {
	return (
		SPECIALIST_HELP?.[scenarioNum]?.[profileId] ||
		"Consulta orientativa: revisa la secuencia clínica del escenario (confirmar → estadificar → decidir → tratar → seguir) y prioriza el dato que cambia la conducta."
	);
}

const SPECIALIST_STORAGE_PREFIX = "specialistHelp:";

export function loadLocalSpecialistHelp(groupId) {
	if (typeof window === "undefined") return null;
	if (!groupId) return null;
	try {
		const raw = localStorage.getItem(`${SPECIALIST_STORAGE_PREFIX}${groupId}`);
		return raw ? JSON.parse(raw) : null;
	} catch {
		return null;
	}
}

export function saveLocalSpecialistHelp(groupId, specialistHelp) {
	if (typeof window === "undefined") return;
	if (!groupId) return;
	try {
		localStorage.setItem(
			`${SPECIALIST_STORAGE_PREFIX}${groupId}`,
			JSON.stringify(specialistHelp || {})
		);
	} catch {
		// noop
	}
}

export function mergeSpecialistHelp(serverHelp, localHelp, totalUses = SPECIALIST_TOTAL_USES) {
	const sUses = typeof serverHelp?.usesLeft === "number" ? serverHelp.usesLeft : totalUses;
	const lUses = typeof localHelp?.usesLeft === "number" ? localHelp.usesLeft : totalUses;
	const usesLeft = Math.min(sUses, lUses);

	const used = {
		...(serverHelp?.used || {}),
		...(localHelp?.used || {}),
	};
	for (const k of Object.keys(localHelp?.used || {})) {
		used[k] = { ...(serverHelp?.used?.[k] || {}), ...(localHelp?.used?.[k] || {}) };
	}

	return { usesLeft, used };
}

